import small from './public/images/wall-8-400.webp';
import medium from './public/images/wall-8-672.webp';
import large from './public/images/wall-8-1152.webp';

export default {
    src: medium,
    srcSet: `${small} 400w, ${medium} 672w, ${large} 1152w`,
    sizes: '(max-width: 639px) calc(100vw - 40px), 576px',
};
